import { render, staticRenderFns } from "./FileEditor.vue?vue&type=template&id=2a3d4365&scoped=true&"
import script from "./FileEditor.vue?vue&type=script&lang=js&"
export * from "./FileEditor.vue?vue&type=script&lang=js&"
import style0 from "./FileEditor.vue?vue&type=style&index=0&id=2a3d4365&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3d4365",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VFileInput,VForm,VTextField,VTextarea})
